import type { Voucher } from '@/types';
import { defineStore } from 'pinia';

export type VoucherState = {
    validVouchers: Voucher[];
    closeAlertOpen: boolean;
    approveAlertOpen: boolean;
    removeAlertOpen: boolean;
    ignoreAlertOpen: boolean;
    markAsMissingModalOpen: boolean;
    statementUploadAlertOpen: boolean;
    assignedModalOpen: boolean;
    projectModalOpen: boolean;
};

export const useVoucherStore = defineStore('voucher', {
    state: (): VoucherState => ({
        validVouchers: [],
        closeAlertOpen: false,
        approveAlertOpen: false,
        removeAlertOpen: false,
        ignoreAlertOpen: false,
        markAsMissingModalOpen: false,
        statementUploadAlertOpen: false,
        assignedModalOpen: false,
        projectModalOpen: false,
    }),
    getters: {
        validVoucherNumbers: (state) =>
            state.validVouchers.map((voucher) => `#${voucher.VoucherNumber}`).join(', '),
        validVoucherIds: (state) => state.validVouchers.map((voucher) => voucher.id),
    },
    actions: {
        setValidVouchers(vouchers: Voucher[]) {
            this.validVouchers = vouchers;
        },
        clearValidVouchers() {
            this.validVouchers = [];
        },
        toggleOpen(
            alert:
                | 'close'
                | 'approve'
                | 'remove'
                | 'ignore'
                | 'mark_as_missing'
                | 'assigned'
                | 'project',
            open: boolean,
        ) {
            if (!open) {
                this.clearValidVouchers();
            }

            switch (alert) {
                case 'close':
                    this.closeAlertOpen = open;
                    break;
                case 'approve':
                    this.approveAlertOpen = open;
                    break;
                case 'remove':
                    this.removeAlertOpen = open;
                    break;
                case 'ignore':
                    this.ignoreAlertOpen = open;
                    break;
                case 'mark_as_missing':
                    this.markAsMissingModalOpen = open;
                    break;
                case 'assigned':
                    this.assignedModalOpen = open;
                    break;
                case 'project':
                    this.projectModalOpen = open;
                    break;
            }
        },
        toggleStatementUploadAlertModal(open: boolean) {
            this.statementUploadAlertOpen = open;
        },
    },
});
